import {Pipe, PipeTransform} from '@angular/core';

@Pipe({
    name: 'truncate',
    standalone: false
})
export class TruncatePipe implements PipeTransform {
  transform(value: string, limit, trail = '...', endlimit = 0): string {
    limit = parseInt(limit, 10) === limit ? limit : 10;

    return value.length > limit ? (value.substring(0, limit) + trail + (endlimit > 0 ? value.substring(value.length - endlimit, value.length) : '')) : value;
  }
}
